var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoorMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.660714 42.2857C10.3732 42.2857 30.0625 42.2857 36.3393 42.2857C36.6696 42.2857 37 42.0214 37 41.625C37 41.2946 36.7357 40.9643 36.3393 40.9643H31.1857V1.91607C31.1857 0.858929 30.3268 0 29.2696 0H7.73036C6.67321 0 5.81429 0.858929 5.81429 1.91607V41.0304H0.660714C0.330357 41.0304 0 41.2946 0 41.6911C0 42.0214 0.330357 42.2857 0.660714 42.2857ZM7.06964 1.91607C7.06964 1.58571 7.33393 1.25536 7.73036 1.25536H29.2696C29.6 1.25536 29.9304 1.51964 29.9304 1.91607V41.0304H7.06964V1.91607Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8482 33.6309H9.64643C9.31607 33.6309 8.98572 33.8951 8.98572 34.2916V38.4541C8.98572 38.7844 9.25 39.1148 9.64643 39.1148H16.8482C17.1786 39.1148 17.5089 38.8505 17.5089 38.4541V34.2916C17.5089 33.8951 17.1786 33.6309 16.8482 33.6309ZM16.1875 37.7934H10.2411V34.8862H16.1875V37.7934Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8482 15.2627H9.64643C9.31607 15.2627 8.98572 15.527 8.98572 15.9234V31.0538C8.98572 31.3841 9.25 31.7145 9.64643 31.7145H16.8482C17.1786 31.7145 17.5089 31.4502 17.5089 31.0538V15.9234C17.5089 15.5931 17.1786 15.2627 16.8482 15.2627ZM16.1875 30.3931H10.2411V16.5181H16.1875V30.3931Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3536 15.2627H20.0197C19.6893 15.2627 19.3589 15.527 19.3589 15.9234V31.0538C19.3589 31.3841 19.6232 31.7145 20.0197 31.7145H27.3536C27.6839 31.7145 28.0143 31.4502 28.0143 31.0538V15.9234C28.0143 15.5931 27.75 15.2627 27.3536 15.2627ZM26.6929 30.3931H20.6804V16.5181H26.6929V30.3931Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3536 33.6309H20.0197C19.6893 33.6309 19.3589 33.8951 19.3589 34.2916V38.4541C19.3589 38.7844 19.6232 39.1148 20.0197 39.1148H27.3536C27.6839 39.1148 28.0143 38.8505 28.0143 38.4541V34.2916C28.0143 33.8951 27.75 33.6309 27.3536 33.6309ZM26.6929 37.7934H20.6804V34.8862H26.6929V37.7934Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3.1709C13.2804 3.1709 8.98572 7.39947 8.98572 12.6852C8.98572 13.0155 9.25 13.3459 9.64643 13.3459H27.3536C27.6839 13.3459 28.0143 13.0816 28.0143 12.6852C28.0143 12.6191 28.0143 12.6191 28.0143 12.553C27.9482 7.39947 23.7196 3.1709 18.5 3.1709ZM17.8393 11.1655L13.1482 6.47447C14.4036 5.35126 16.0554 4.69054 17.8393 4.49233V11.1655ZM19.1607 4.49233C20.9446 4.62447 22.5964 5.35126 23.8518 6.47447L19.1607 11.1655V4.49233ZM12.2232 7.39947L16.9143 12.0905H10.3071C10.4393 10.3066 11.1661 8.65483 12.2232 7.39947ZM20.0196 12.0905L24.7107 7.39947C25.8339 8.65483 26.4946 10.3066 26.6929 12.0905H20.0196Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 41.9115,
    y2: 36.6726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.98572,
    y1: 33.6309,
    x2: 13.9765,
    y2: 41.3876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 8.98572,
    y1: 15.2627,
    x2: 22.425,
    y2: 22.2252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 19.3589,
    y1: 15.2627,
    x2: 32.917,
    y2: 22.3956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 19.3589,
    y1: 33.6309,
    x2: 24.3175,
    y2: 41.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 8.98572,
    y1: 3.1709,
    x2: 17.4478,
    y2: 18.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoorMain);
export default __webpack_public_path__ + "static/media/icon-door-main.68e855ba29ff2f9a1eea57e7d1a14e5e.svg";
export { ForwardRef as ReactComponent };